enum FileSource {
  ipfs = 'ipfs',
  s3 = 's3',
}

export default FileSource
